import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import ProjectCards from "./ProjectCards";
import P3KCARSImg from "../../Assets/Projects/P3KCARS.png";
import PTSIImg from "../../Assets/Projects/PTSI.png";
import ResortifyPHImg from "../../Assets/Projects/RESORTIFYPH.png";
import IIAImg from "../../Assets/Projects/IIA.png";
import HIKESAFEImg from "../../Assets/Projects/HIKESAFE.png";
import EASYJOURNALImg from "../../Assets/Projects/EASYJOURNAL.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>Here are a few projects I’ve worked on.</p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCards
              imgPath={P3KCARSImg}
              title="P3KCARS"
              description="Public website with responsive UI and clean navigation."
              demoLink="https://p3kcars.com"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCards
              imgPath={PTSIImg}
              title="PTSI"
              description="Company site deployed to Firebase Hosting."
              demoLink="https://ptsi-ca79a.web.app"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCards
              imgPath={ResortifyPHImg}
              title="RESORTIFYPH"
              description="Resort booking platform (under development)."
              demoLink="https://resortifyph.me"
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCards
              imgPath={IIAImg}
              title="IIA"
              description="Organization website: content, resources, and membership info."
              demoLink="https://iia-p.org"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCards
              imgPath={HIKESAFEImg}
              title="HIKESAFE"
              description="Safety-focused hiking app; code available on GitHub."
              ghLink="https://github.com/B1Kjuu/hikesafenew"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCards
              imgPath={EASYJOURNALImg}
              title="EASYJOURNAL"
              description="Simple journaling app; repository with implementation details."
              ghLink="https://github.com/B1Kjuu/EasyJournal"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
